import React, { useState } from 'react';
import {useStyles} from "./ShowContactDetails.style";
import ShowContactDetailsProperties from "./ShowContactDetailsProperties";
import clsx from 'clsx';
import ProfileImagePlaceholder from '../../../ui_components/Icon/ProfileImagePlaceholder';
import ShowDifficultPersonIndicator from '../ShowDifficultPersonIndicator/ShowDifficultPersonIndicator';
import ContactPhoneIcon from "@mui/icons-material/ContactPhone";
import HomeIcon from '@mui/icons-material/Home';
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { useI18nContext } from '../../../contexts/I18nContext';
import { format } from '../../../util/PhoneFormatter';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { IconButton, Tooltip } from '@mui/material';
import Snackbar, { SnackbarCloseReason } from '@mui/material/Snackbar';

const ShowContactDetails: React.FC<ShowContactDetailsProperties> = ({
                                                          contact,
                                                          className
                                                      }) => {
    const classes = useStyles();
    const i18n = useI18nContext();
    const [openSnackbar, setOpenSnackbar] = useState(false);

    const handleClose = (
        event: React.SyntheticEvent | Event,
        reason?: SnackbarCloseReason,
    ) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnackbar(false);
    };

    const handleCopy = (text: string) => {
        navigator.clipboard.writeText(text)
        .then(() => {
            setOpenSnackbar(true);
        })
        .catch((err) => {
            console.error('Erro ao copiar:', err);
        });
    };

    return (
        <div className={clsx(className,classes.details_container)}>
            <div className={classes.header_container}>
                <h2>Destinatario</h2>
            </div>
            <div className={clsx(classes.name_icon_container,classes.hide_small)}>
                <ProfileImagePlaceholder
                    fontSize={35}
                    name={contact?.name}/>
            </div>
            <div className={classes.row_container}>
                <div className={classes.label_container}>
                    <strong>{i18n.translate("NAME")}:</strong>
                </div>
                <div className={classes.row_container_right}>
                    <strong><span>{contact?.name + ' ' + contact?.lastName}</span></strong>
                    <Tooltip title="Copiar" placement={'top'}>
                        <IconButton size="small" onClick={() => handleCopy(contact?.name + ' ' + contact?.lastName)}>
                            <ContentCopyIcon fontSize="small" className={classes.copy_btn} />
                        </IconButton>
                    </Tooltip>
                </div>
            </div>

            {contact?.documentId &&
                <div className={classes.row_container}>
                    <div className={classes.label_container}>
                        <strong>Carnet de identidad:</strong>
                    </div>
                    <div className={classes.row_container_right}>
                        <div><strong><span>{contact?.documentId}</span></strong></div>
                        <Tooltip title="Copiar" placement={'top'}>
                            <IconButton size="small" onClick={() => handleCopy(contact?.documentId)}>
                                <ContentCopyIcon fontSize="small" className={classes.copy_btn} />
                            </IconButton>
                        </Tooltip>
                    </div>
                </div>}

            {contact?.mobilePhone &&
                <div className={classes.row_container}>
                    <div className={classes.label_container}>
                        <strong>{i18n.translate("MOBILE_PHONE")}:</strong>
                    </div>
                    <div className={classes.row_container_right}>
                        <div className={classes.display_flex}>
                            <ContactPhoneIcon/>
                            <div><strong><span>{format(contact.mobilePhone)}</span></strong></div>
                        </div>
                        <Tooltip title="Copiar" placement={'top'}>
                            <IconButton size="small" onClick={() => handleCopy(contact?.mobilePhone?.number!!)}>
                                <ContentCopyIcon fontSize="small" className={classes.copy_btn} />
                            </IconButton>
                        </Tooltip>
                    </div>
                </div>}

            {contact?.secondMobilePhone &&
                <div className={classes.row_container}>
                    <div className={classes.label_container}>
                        <strong>{i18n.translate("SECOND_MOBILE_PHONE")}:</strong>
                    </div>
                    <div className={classes.row_container_right}>
                        <div className={classes.display_flex}>
                            <ContactPhoneIcon/>
                            <div>
                                <strong><span>{format(contact.secondMobilePhone)}</span></strong>
                            </div>
                        </div>
                        <Tooltip title="Copiar" placement={'top'}>
                            <IconButton size="small" onClick={() => handleCopy(contact.secondMobilePhone?.number!!)}>
                                <ContentCopyIcon fontSize="small" className={classes.copy_btn} />
                            </IconButton>
                        </Tooltip>
                    </div>
                </div>}

            {contact?.homePhone &&
                <div className={classes.row_container}>
                    <div className={classes.label_container}>
                        <strong>{i18n.translate("HOME_PHONE")}:</strong>
                    </div>
                    <div className={classes.row_container_right}>
                        <div className={classes.display_flex}>
                            <ContactPhoneIcon/>
                            <div><strong><span>{format(contact?.homePhone)}</span></strong></div>
                        </div>
                        <Tooltip title="Copiar" placement={'top'}>
                            <IconButton size="small" onClick={() => handleCopy(contact.homePhone?.number!!)}>
                                <ContentCopyIcon fontSize="small" className={classes.copy_btn} />
                            </IconButton>
                        </Tooltip>
                    </div>
                </div>}

            {contact?.address &&
                <div className={classes.row_container}>
                    <div className={classes.label_container}>
                        <strong>{i18n.translate("ADDRESS")}:</strong>
                    </div>
                    <div className={classes.row_container_right}>
                        <div className={classes.display_flex}>
                            <HomeIcon/>
                            <div>
                                <strong><span>{contact?.address}</span><span>{contact?.neighborhood ? '. ' + contact?.neighborhood : ''}</span></strong>
                            </div>
                        </div>
                        <Tooltip title="Copiar" placement={'top'}>
                            <IconButton size="small" onClick={() => handleCopy(contact?.address + '. ' + (contact?.neighborhood ? '. ' + contact?.neighborhood : ''))}>
                                <ContentCopyIcon fontSize="small" className={classes.copy_btn} />
                            </IconButton>
                        </Tooltip>
                    </div>
                </div>}

            {contact?.geo &&
                <div className={classes.row_container}>
                    <div className={classes.label_container}>
                        <strong>{i18n.translate("LOCALIZATION")}:</strong>
                    </div>
                    <div className={classes.row_container_right}>
                        <div className={classes.display_flex}>
                            <LocationOnIcon/>
                            <div>
                                <strong><span>{contact?.geo.name}. {contact?.geo.parentInfo}</span></strong>
                            </div>
                        </div>
                        <Tooltip title="Copiar" placement={'top'}>
                            <IconButton size="small" onClick={() => handleCopy(contact?.geo?.name + '. ' + contact?.geo?.parentInfo)}>
                                <ContentCopyIcon fontSize="small" className={classes.copy_btn} />
                            </IconButton>
                        </Tooltip>
                    </div>
                </div>}

            {contact?.observation &&
                <div className={classes.row_container}>
                    <div>
                        <strong>Observación:</strong>
                    </div>
                    <div className={classes.row_container_right}>
                        <div><strong><span>{contact?.observation}</span></strong></div>
                    </div>
                </div>}

            {contact?.difficultPerson &&
                <div className={classes.difficult_person_indicator_container}>
                    <ShowDifficultPersonIndicator
                        difficultPerson={contact?.difficultPerson}/>
                </div>}

            <Snackbar
                open={openSnackbar}
                autoHideDuration={4000}
                onClose={handleClose}
                message="Copiado"
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            />
        </div>
    )
}
export default ShowContactDetails;